import React from "react";
import PropTypes from "prop-types";
import { Controller } from "../Controller";
import cname from "../../style.module.scss";
import { Vector } from "../../SpectrophotometerImages";
import { Accordian } from "@learningblocks/storybook-components";
import { DataTable } from "@learningblocks/shared-components";
import { ACCORDIAN_SMALL } from "../../Spectrophotometer.utils";

export function Content(props) {
  const [accordian, updateAccordian] = React.useState(ACCORDIAN_SMALL);

  const onSelectTab = (tabId) => {
    const selectTab = (tab) => {
      if (tab.id === tabId) return { ...tab, open: true };
      else return { ...tab, open: false };
    };
    updateAccordian((acc) => acc.map(selectTab));
  };

  const status = props.cuvetteId ? "Yes" : "No";

  return (
    <>
      <div className={cname.left}>
        <Vector className={cname.vector} />
        <p className={cname.text}>Set the spectrophotometer</p>
        <p style={{ marginTop: 0 }}>
          Use the second column [Abs (615 nm)] to record your absorbance values.
          All values will be rounded to 2 decimal points. The corresponding pH
          values will be determined later.
        </p>
        <DataTable
          className={cname.dataTable}
          indices={props.absorbanceTable.indices}
          data={props.absorbanceTable.data}
          onCellChange={(e) => {
            props.absorbanceTableCellUpdate(e);
          }}
        />
        <Accordian
          className={cname.accordian}
          allTabs={accordian}
          onSelectTab={onSelectTab}
        />
        <div className={cname[`status_${status}`]}>
          <p>Cuvette Inserted: {status}</p>
        </div>
      </div>
      <div className={cname.right}>
        <Controller
          poweredUp={props.poweredUp}
          wavelength={props.wavelength}
          setWavelength={props.setWavelength}
          absorbanceValue={props.absorbanceValue}
          onClickZeroButton={props.onClickZeroButton}
          relativeAbsorbance={props.relativeAbsorbance}
          onClickPowerButton={props.onClickPowerButton}
        />
      </div>
    </>
  );
}

Content.propTypes = {
  /**
   * Boolean to set if spectrophotometer is on/off
   */
  poweredUp: PropTypes.bool,
  /**
   * Absorbance value of solution inside the cuvette
   */
  absorbanceValue: PropTypes.number,
  /**
   * Relative absorbance value set
   */
  relativeAbsorbance: PropTypes.number,
  /**
   * Callback for PowerButton click
   */
  onClickPowerButton: PropTypes.func,
  /**
   * Callback for ZeroButton click
   */
  onClickZeroButton: PropTypes.func,
  /**
   * Current wavelenght
   */
  wavelength: PropTypes.number,
  /**
   * Callback function to set wavelength value
   */
  setWavelength: PropTypes.func,
};

Content.defaultProp = {};
